// Styled Components
import styled from "styled-components";

const InfoTwo = () => {
  return (
    <Wrapper>
      <div className="section-1">
        <p className="header">
          COMPLETE SHOEUZIS ARE BROKEN DOWN INTO 4 TRAIT TYPES
        </p>
        <p className="info">
          To generate a complete nft, you must collect scattered shoeuzi nfts
          that when combined, sum up to all the traits of a Complete design.
        </p>
      </div>
      <div className="section-2">
        <div className="item">UPPER</div>
        <div className="item">MID</div>
        <div className="item">LOWER</div>
        <div className="item">ACCENT</div>
      </div>
    </Wrapper>
  );
};

export default InfoTwo;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;

  //
  padding-top: 150px;
  @media only screen and (max-width: 1000px) {
    padding-top: 100px;
  }
  //

  //
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media only screen and (max-width: 1075px) {
    flex-direction: column;
    gap: 50px;
  }
  //

  .section-1 {
    //
    width: 520px;
    @media only screen and (max-width: 550px) {
      width: 100%;
    }
    //

    .header {
      font-family: "Pixeltype";
      font-weight: 200;

      line-height: 48px;

      //    line-height: 30px;

      font-size: 2rem;

      //
      width: 400px;
      @media only screen and (max-width: 1075px) {
        width: 520px;
      }
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
    }

    .info {
      color: #8f8f8f;
      font-size: 1.2rem;
      padding-top: 30px;

      line-height: 31px;

      color: #fff;
      font-family: "Open Sans", sans-serif;
      font-weight: 300;
      //
      width: 400px;
      @media only screen and (max-width: 1075px) {
        width: 520px;
      }
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
    }
  }

  .section-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 25px;

    //
    width: 520px;
    @media only screen and (max-width: 550px) {
      width: 100%;
    }
    //

    .item {
      width: 100%;
      height: 50px;
      background-color: #000;
      font-size: 1.4rem;

      display: flex;
      justify-content: center;
      align-items: center;

      font-family: "Pixeltype";
    }
  }
`;
